<template>
  <div class="sidebar" :class="{'active': open}">
      <div class='wallet-conect' style='margin-top: 20px; margin-bottom: 20px;'>
        <div class='p-2 mb-0 text-center'>
          <div v-if = 'walletIsConect' class='address'>
            <h6>{{getAddress}}</h6>
          </div>
          <b-button
            v-else
            @click='walletConect()'
            variant='primary'
          >
            Connect to wallet
          </b-button>
        </div>
      </div>
      <ul>
        <li v-for="(item, index) in menu" v-bind:key='index'>
          <componet
            is="router-link"
            v-bind = 'item'
          >
            <div class='item' @click = 'itemToggled(item)'>
              <div class= 'wrapper-icon'>
                <component
                  :is="item.icon"
                  v-bind='item.properties'
                />
              </div>
              <div class='item-title'>
                <span>{{item.title}}</span>
                <font-awesome-icon
                  v-if = 'item.child'
                  :icon = "['fas', isItemToggled(item) ? 'angle-down': 'angle-up']"
                  pull = 'right'
                />
              </div>
            </div>
          </componet>
          <!-- elementos hijos -->
          <ul v-if = 'item.child' :style="{display: isItemToggled(item) ? 'none': 'block'}">
            <li v-for="(item_child, index_child) in item.child" v-bind:key='index_child'>
              <router-link :to="item_child.to" >
                <div class='item' @click="hideMenu">
                  <div class= 'wrapper-icon'>
                    <component
                      :is="item_child.icon"
                      v-bind='item_child.properties'
                    />
                  </div>
                  <div class='item-title'>
                    <span> {{item_child.title}}</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </li>
        <!-- Disconnect wallet -->
        <li v-if = 'walletIsConect'>
          <componet
            is="router-link"
            to=""
            event=""
            @click.native="logout">
            <div class='item'>
              <div class= 'wrapper-icon' style="padding-left: 5px;">
                <component
                  :is= "require('../components/icons/menu/SalirIcon.vue').default"
                />
              </div>
              <div class='item-title'>
                <span>Disconnect wallet</span>
              </div>
            </div>
          </componet>
        </li>
      </ul>
      <div style='height: 120px;'></div>
      <Login
        :openModal = 'this.openModal'
        @setOpenModal= 'setOpenModal'
      />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Login from '@/components/wallet/login'

export default {
  components: {
    Login
  },
  props: [
    'open',
    'menu'
  ],
  data () {
    return {
      address: '',
      isConect: false,
      openModal: false
    }
  },
  methods: {
    setOpenModal: function (value) { this.openModal = value },
    walletConect () {
      // this.isConect = !this.isConect
      // console.log('wallet conect')
      this.openModal = true
    },
    logout () {
      this.$store.dispatch('auth/logoutWallet')
    },
    itemToggled (item) {
      if (!item.child) { this.hideMenu() }
      item.toggled = !item.toggled
    },
    isItemToggled (item) { return item.toggled },
    async hideMenu () {
      this.$emit('update:open', false)
      console.log('hideMenu2')
    }
  },
  computed: {
    ...mapGetters({
      getAddress: 'getAddress',
      getStatusAuthWallet: 'auth/getStatusAuthWallet',
      getOptionsAuthWallet: 'auth/getOptionsAuthWallet'
    }),
    walletIsConect () {
      return this.getStatusAuthWallet === this.getOptionsAuthWallet.LOGGED_IN
    }
  },
  created () { },
  updated () {
    console.log('updated sidebar')
  }
}
</script>

<style scoped>
  .sidebar {
    font-family: "Poppins-Light";
    margin: 0px;
    padding: 0px;

    height: 100%;
    overflow: auto;

    position: fixed;
    left: -250px;
    width: 250px;

    transition: left 0.5s;
    z-index: 1;

    background-color: #282828;
    /*borde superior resaltado*/
    border-top: 3px solid #282828;
  }

  .sidebar.active {
    left: 0px;
  }
  .sidebar::-webkit-scrollbar {
    width: 8px; /* Tamaño del scroll en vertical */
    height: 8px; /* Tamaño del scroll en horizontal */
    display: none; /* Ocultar scroll */
  }
  .wallet-conect button {
    padding: 6px 16px 4px 16px;
  }

  .wallet-conect .address {
    border: 1px solid #fedc57ff !important;
    border-radius: 10px !important;
    padding: 10px;
    width: 180px;
    margin: auto;
  }
  .wallet-conect .address h6 {
    font-family: 'Poppins-Light';
    font-style: normal;
    font-weight: normal;

    color: #fedc57ff !important;
    width: 150px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: auto;
  }
  /* lista e item*/
  .sidebar ul{
    /*overflow:hidden;*/
    list-style:none;
    padding-left: 0px;
  }

  .sidebar li .item {
    display: flex;
    margin-bottom: 0px;
    padding: 5px 20px;
    height: 48px;
  }
  .sidebar li ul{
    background-color: #333333ff;
  }
  .sidebar li ul .item {
    padding: 5px 40px;
  }
  .sidebar li .item:hover {
    background-color: #fedc57df;
  }
  .sidebar li .item-title {
    display: block;
    color: #ecececff;
    font-style: normal;
    width: 100%;
    font-size: 14px;
    padding-top: 9px;
    margin-left: 9px;
    margin-right: 9px;
  }
  .sidebar li .wrapper-icon {
    width: 25px;
    height: 25px;
    margin-top: 6px;
    /* background-color: #ffff; */
  }
  .sidebar li  a,
  .sidebar p,
  .sidebar li > span {
    display: block;
    text-decoration: none;
  }

  .svg-inline--fa.fa-pull-right {
    margin-top: 0.3em;
  }

  /*xs*/
  @media screen and (max-width: 575.99px) {
    .sidebar {
      left: -100%;
    }
    .sidebar.active {
      width: 100%;
    }
  }
</style>
